// Vendors
import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

const SearchField = ({ currentRefinement, refine }) => (
  <span className="form__input-group-search u--display-block">
    <input
      type="search"
      placeholder="Search by Keyword"
      className="form__input"
      value={currentRefinement}
      onChange={(event) => refine(event.currentTarget.value)}
    />
  </span>
);

export default connectSearchBox(SearchField);
